<template>
  <div class="input-time-select-wrapper">

    <div class="current-label">
      <p>{{ currentLabel }}</p>
    </div>

    <div class="input-time-select">
      <div v-if="format.includes('HH')">
        <label>{{ $t('form.labels.hours') }}</label>
        <input-select
            placeholder="Hours"
            :selected-value="time.hours"
            :options="hours"
            :preselect-first="true"
            :allow-empty="false"
            custom-caret-class="no-caret"
            @change="(val) => $emit('selectTime', { key: 'hours', hours: val })"
        />
      </div>
      <div v-if="formatLength > 1" class="divide"><span>:</span></div>
      <div v-if="format.includes('MM')">
        <label>{{ $t('form.labels.minutes') }}</label>
        <input-select
            placeholder="Minutes"
            :selected-value="time.minutes"
            :options="minutes"
            :preselect-first="true"
            :allow-empty="false"
            custom-caret-class="no-caret"
            @change="(val) => $emit('selectTime', { key: 'minutes', minutes: val})"
        />
      </div>
      <div v-if="formatLength > 2" class="divide"><span>:</span></div>
      <div v-if="format.includes('SS')">
        <label>{{ $t('form.labels.seconds') }}</label>
        <input-select
            placeholder="Seconds"
            :selected-value="time.seconds"
            :options="seconds"
            :preselect-first="true"
            :allow-empty="false"
            custom-caret-class="no-caret"
            @change="(val) => $emit('selectTime', { key: 'seconds', seconds: val })"
        />
      </div>
    </div>

    <div v-if="clearable && hasValue" class="clear-icon" @click="$emit('clearTime')">
      <i class="fas fa-times"/>
    </div>

  </div>
</template>

<script>
import InputSelect from '../../form-components/input-select';

export default {
  name: "HourMinuteSelect",

  props: {
    time: {
      type: Object,
      default: () => {}
    },
    format: {
      type: String,
      default: 'MM:HH:SS'
    },
    options: {
      type: Object,
      default: () => {}
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    optionsData() { return this.options && this.options.options },

    currentLabel() { return this.optionsData && this.optionsData.currentLabel || 'Time:' },

    hours() {
      if(this.optionsData && this.optionsData['HH']) return this.optionsData['HH']
      return [...Array(24).keys()].map(num => ({ label: this.numberToString(num), value: num }))
    },
    minutes() {
      if(this.optionsData && this.optionsData['MM']) return this.optionsData['MM']
      return [...Array(60).keys()].map(num => ({ label: this.numberToString(num), value: num }))
    },
    seconds() {
      if(this.optionsData && this.optionsData['SS']) return this.optionsData['SS']
      return [...Array(60).keys()].map(num => ({ label: this.numberToString(num), value: num }))
    },

    hasValue() {
      const { hours, minutes, seconds } = this.time

      if(hours === 0 && minutes === 0 && seconds === 0) return false

      return (hours !== undefined && hours !== null)
          || (minutes !== undefined && minutes !== null)
          || (seconds !== undefined && seconds !== null)
    },
    formatLength() { return this.format.split(':').length }
  },

  methods: {
    numberToString(n) {
      let numString = n.toString()
      if(n < 10) numString = `0${n}`
      return numString
    }
  },

  components: {
    InputSelect
  }
}
</script>

<style lang="scss">

@import '../../../styles/base/variables.scss';

.input-time-select-wrapper {
  display: flex;
  align-items: center;

   p {
     margin-bottom: 0;
     margin-right: 1rem;
   }

  .current-label {
    min-width: 85px;
  }

  .divide {
    margin: 0 0.2rem;
  }

  .clear-icon {
    margin-left: 1rem;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: $red;
    }
  }

  .input-select.multiselect .multiselect__content-wrapper { // no scrollbar
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */

    &::-webkit-scrollbar {
      display: none;  /* Safari and Chrome */
    }
  }
}

.input-time-select {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  > div  {
    position: relative;
  }

  label {
    position: absolute;
    width: 100%;
    text-align: center;
    top: -1.2rem;
    margin: 0;
    z-index: 10;
    font-size: .7rem;
    color: $light-gray;
  }

  .input-select.multiselect {
    max-width: 75px;
    min-width: 60px;

    div.multiselect__tags {
      display: flex;
      align-items: center;
      text-align: center;
      padding: 0;
      background-color: $off-white;

      .multiselect__placeholder, .multiselect__single {
        padding: 0;
      }
    }
  }

  .multiselect__option {
    text-align: center;
  }
}

</style>